if (window.innerWidth > 1024){
    // 数量改变
    function productBottomAddCartChangeQuantity(type){

        var currentQuantity = parseInt($('#productBottomAddCartQuantityInput').val());

        switch (type){
            // 减少
            case 'decrease':
                if (currentQuantity > 1){
                    currentQuantity = currentQuantity - 1;
                }
                break;
            // 增加
            case 'add':
                if (currentQuantity < 1000){
                    currentQuantity = currentQuantity + 1;
                }
                break;
        }

        // 设置值
        $('#productBottomAddCartQuantityInput').val(currentQuantity);
        $('#productBottomAddCartQuantityFrom').val(currentQuantity);
    }

    // 监听修改数量
    $("#productBottomAddCartQuantityInput").bind('input propertychange',function(event){
        // 当前值
        let currentQuantity = $(this).val();
        $("#productBottomAddCartQuantityInput").val(currentQuantity);
    });
}



